/**
 * The shared API client (`useCamelCase: true`) deep-camelizes every response
 * key — including *dynamic* keys that are data, not schema: experiment names
 * in `variants` (`rag_engine` → `ragEngine`) and `agent_events.payload` keys
 * (`match_step` → `matchStep`). Operators correlate this UI with SQL over
 * Postgres, so we restore the original snake_case identifiers for display
 * and for payload-based logic.
 */
export const decamelizeKey = (key: string): string => key.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();

export const decamelizeKeysDeep = (value: unknown): unknown => {
	if (Array.isArray(value)) return value.map(decamelizeKeysDeep);
	if (value !== null && typeof value === 'object') {
		return Object.fromEntries(
			Object.entries(value as Record<string, unknown>).map(([k, v]) => [decamelizeKey(k), decamelizeKeysDeep(v)]),
		);
	}
	return value;
};
